import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";

const Gallery = () => (
  <Box sx={{ p:4 }}>
    <Typography variant="h4" fontWeight={700} mb={3}>Photos & Notes</Typography>
  </Box>
);
export default Gallery;
